<mat-dialog-content>
	<div class="col-12 col-lg-12 col-md-12 col-xl-12 text-center">
        <img src="{{ data.url ? data.url : '' }}" alt="" width="{{data.width < 100 ? 500 : data.width}}" height="{{data.hight < 100 ? 500 : data.hight}}" class="img-fluid c_image">
    </div>
</mat-dialog-content>
<mat-dialog-actions align="center">
	<button mat-raised-button mat-dialog-close tabindex="-1">{{cancelButtonText}}</button>
</mat-dialog-actions>